module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Product"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.chodata.shortcutIconUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.chodata.shortcutDescription))]), _vm._v(" "), _c('div', {
    staticClass: "wraps"
  }, _vm._l((_vm.chodata.products), function(mes) {
    return _c('div', {
      key: mes.id,
      staticClass: "wrap"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/myy/Productdetail',
          query: {
            id: mes.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "wrap-out"
    }, [_c('img', {
      staticClass: "icon",
      attrs: {
        "src": mes.productIconUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "tit1"
    }, [_vm._v(_vm._s(mes.productTitle))]), _vm._v(" "), _c('p', {
      staticClass: "tit2"
    }, [_vm._v(_vm._s(mes.productSummary))])])])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-101bc0e4"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 274
// module chunks = 1